import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/profile";
    if (!sessionId) { navigate(target, { replace: true }); return; }
    api.post("/auth/session", { session_id: sessionId })
      .then(async () => { await refresh(); window.history.replaceState({}, "", target); navigate(target, { replace: true }); })
      .catch(() => navigate("/login", { replace: true }));
  }, []); // eslint-disable-line

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <Loader2 className="h-8 w-8 animate-spin gold-text" />
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
